var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m351.885 174.784c-59.894 0-49.34 49.409-109.235 49.409-14.465 0-99.378-49.409-113.842-49.409-38.044 0-76.088 0-114.132 0-19.47 111.56-19.47 225.649 0 337.209h337.209c19.47-111.56 19.47-225.649 0-337.209z",
    fill: "#e49542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.166 512h-54.49c-19.453-111.569-19.453-225.647 0-337.216h54.49c-19.48 111.569-19.48 225.647 0 337.216z",
    fill: "#e28424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.753 316.585-49.401-31.144c-3.099-1.953-7.044-1.953-10.142 0l-34.821 21.952c-6.332 3.992-14.58-.559-14.58-8.044v-124.565h108.945v141.801z",
    fill: "#db5c6e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m402.834.722c-51.926-1.89-103.845-.068-155.764 5.457-14.443 1.533-25.751 13.099-26.904 27.572-7.483 93.835-7.483 187.67 0 281.512 1.154 14.473 12.462 26.039 26.904 27.572 77.442 8.242 154.891 8.242 232.341 0 14.435-1.533 25.751-13.099 26.904-27.572 5.586-70.088 7.005-140.168 4.242-210.248",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.558 105.015c-25.523-.918-51.046-2.74-76.577-5.457-14.435-1.533-25.751-13.099-26.904-27.572-1.897-23.755-3.309-47.509-4.242-71.264 25.522.918 106.789 80.538 107.723 104.293z",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m270.882 153.046c-2.768 0-5.33-1.482-6.707-3.893l-12.576-22.009c-2.117-3.705-.83-8.425 2.875-10.542 3.703-2.117 8.423-.83 10.542 2.875l5.493 9.612 16.553-32.354c1.945-3.8 6.601-5.301 10.397-3.359 3.799 1.944 5.303 6.599 3.359 10.397l-23.056 45.065c-1.292 2.525-3.864 4.139-6.699 4.205-.061.002-.121.003-.181.003z",
    fill: "#95d6a4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#407093"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m392.959 123.701h-73.867c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h73.867c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.622 150.95h-142.53c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h142.53c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m270.882 228.503c-2.768 0-5.33-1.482-6.707-3.893l-12.576-22.009c-2.117-3.705-.83-8.425 2.875-10.542 3.703-2.117 8.423-.83 10.542 2.875l5.493 9.612 16.553-32.354c1.945-3.8 6.601-5.301 10.397-3.359 3.799 1.944 5.303 6.599 3.359 10.397l-23.056 45.065c-1.292 2.525-3.864 4.14-6.699 4.205-.061.003-.121.003-.181.003z",
    fill: "#95d6a4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#407093"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m392.959 199.158h-73.867c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h73.867c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.237 226.404h-140.148c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h140.149c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.727 7.726z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m270.882 303.96c-2.768 0-5.33-1.482-6.707-3.893l-12.576-22.009c-2.117-3.705-.83-8.425 2.875-10.542 3.703-2.118 8.423-.83 10.542 2.875l5.493 9.612 16.553-32.354c1.945-3.8 6.601-5.302 10.397-3.359 3.799 1.944 5.303 6.599 3.359 10.397l-23.056 45.065c-1.292 2.525-3.864 4.139-6.699 4.205-.061.003-.121.003-.181.003z",
    fill: "#95d6a4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#407093"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m392.959 274.616h-73.867c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h73.867c4.268 0 7.726 3.459 7.726 7.726 0 4.266-3.459 7.726-7.726 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.66 301.868h-84.571c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h84.571c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m133.302 471.87c-26.264 2.202-52.528 2.202-78.792 0-7.188-.603-12.874-6.288-13.476-13.476-2.202-26.264-2.202-52.528 0-78.792.603-7.188 6.288-12.874 13.476-13.476 26.264-2.202 52.528-2.202 78.792 0 7.188.603 12.874 6.288 13.476 13.476 2.202 26.264 2.202 52.528 0 78.792-.602 7.188-6.288 12.873-13.476 13.476z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#dbdbdb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m121.452 411.372h-55.091c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h55.091c4.267 0 7.726 3.459 7.726 7.726 0 4.266-3.459 7.726-7.726 7.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.452 442.077h-55.091c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h55.091c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.3d187f406ce5bd264b5d1bc0ccf01565.svg";
export { ForwardRef as ReactComponent };